<template>
  <div class="agent-scene">
    <div class="agent-card">

      <!-- ── Header ── -->
      <header class="agent-card__header">
        <span class="header__title">Agent overview</span>
        <div class="header__owner">
          <img
            class="header__owner-avatar"
            src="https://i.pravatar.cc/32?img=49"
            alt="Alex Morgan"
          />
          <span class="header__owner-label">Owner: <strong>Alex Morgan</strong></span>
        </div>
      </header>

      <!-- ── Body ── -->
      <section class="agent-card__body">

        <div class="status-badge">
          <span class="status-badge__dot"></span>
          <span class="status-badge__text">ACTIVE</span>
        </div>

        <div class="agent-profile">
          <div class="agent-profile__avatar-wrap">
            <img
              class="agent-profile__avatar"
              src="https://mockmind-api.uifaces.co/content/abstract/1.jpg"
              alt="Jake"
              @error="onAvatarError"
            />
          </div>

          <div class="agent-profile__info">
            <h2 class="agent-profile__name">Jake</h2>
            <p class="agent-profile__role">EXECUTIVE ASSISTANT</p>

            <div class="agent-profile__badges">
              <span class="tool-badge">
                <svg class="tool-badge__icon" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0.5" y="0.5" width="19" height="15" rx="1.5" fill="white" stroke="#e0e0e0"/>
                  <path d="M0.5 2.5L10 9.5L19.5 2.5" stroke="#EA4335" stroke-width="1.2"/>
                  <path d="M0 2L10 9.5L20 2V0H0V2Z" fill="#EA4335" opacity="0.9"/>
                </svg>
                Gmail
              </span>

              <span class="tool-badge">
                <svg class="tool-badge__icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0.5" y="1.5" width="15" height="14" rx="2" fill="white" stroke="#e0e0e0"/>
                  <rect x="0.5" y="1.5" width="15" height="4" rx="2" fill="#4285F4"/>
                  <rect x="0.5" y="3.5" width="15" height="2" fill="#4285F4"/>
                  <rect x="3" y="8" width="2" height="2" rx="0.5" fill="#EA4335"/>
                  <rect x="7" y="8" width="2" height="2" rx="0.5" fill="#FBBC05"/>
                  <rect x="11" y="8" width="2" height="2" rx="0.5" fill="#34A853"/>
                  <rect x="3" y="11" width="2" height="2" rx="0.5" fill="#34A853"/>
                  <rect x="7" y="11" width="2" height="2" rx="0.5" fill="#4285F4"/>
                  <rect x="11" y="11" width="2" height="2" rx="0.5" fill="#EA4335"/>
                  <line x1="4" y1="0" x2="4" y2="3" stroke="#666" stroke-width="1.2" stroke-linecap="round"/>
                  <line x1="12" y1="0" x2="12" y2="3" stroke="#666" stroke-width="1.2" stroke-linecap="round"/>
                </svg>
                Google Calendar
              </span>

              <span class="tool-badge">
                <svg class="tool-badge__icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="16" height="16" rx="3" fill="#191919"/>
                  <path d="M4.5 3.8h2.2l4.8 6.4V3.8H13V12h-2.1L6 5.6V12H4.5V3.8Z" fill="white"/>
                </svg>
                Notion
              </span>

              <span class="tool-badge tool-badge--count">+2</span>
            </div>
          </div>
        </div>

        <div class="agent-card__divider"></div>

        <!-- ── Current Task ── -->
        <div class="agent-task">
          <span class="agent-task__label">CURRENT TASK</span>

          <div class="agent-task__waveform">
            <span
              v-for="(bar, i) in waveformBars"
              :key="i"
              class="waveform-bar"
              :class="{ 'waveform-bar--played': i < playedCount }"
              :style="{ height: bar + 'px' }"
            ></span>
          </div>

          <div class="agent-task__meta">
            <span class="agent-task__name">GENERATE FOLLOW-UP EMAILS</span>
            <span class="agent-task__tokens">3.2K TOKENS</span>
          </div>
        </div>

      </section>

      <!-- ── Footer ── -->
      <footer class="agent-card__footer">
        <div class="footer-controls">
          <button class="btn-icon" aria-label="More options">
            <svg viewBox="0 0 4 16" width="4" height="16" fill="#888">
              <circle cx="2" cy="2" r="1.5"/>
              <circle cx="2" cy="8" r="1.5"/>
              <circle cx="2" cy="14" r="1.5"/>
            </svg>
          </button>

          <button class="btn-icon" aria-label="Terminal">
            <svg viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="#888" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
              <rect x="1" y="1" width="14" height="14" rx="2"/>
              <path d="M4 6l3 2.5L4 11"/>
              <path d="M9 11h3"/>
            </svg>
          </button>

          <button class="btn-pause">
            <svg viewBox="0 0 10 12" width="10" height="12" fill="currentColor">
              <rect x="0" y="0" width="3.5" height="12" rx="1"/>
              <rect x="6.5" y="0" width="3.5" height="12" rx="1"/>
            </svg>
            PAUSE
          </button>
        </div>

        <div class="footer-info">
          <span class="footer-info__last-active">LAST ACTIVE: JUST NOW</span>
          <button class="btn-details">View details</button>
        </div>
      </footer>

    </div>
  </div>
</template>

<script>
export default {
  name: 'AgentCard',
  computed: {
    waveformBars() {
      const total = 76;
      return Array.from({ length: total }, (_, i) => {
        const t = i / total;
        const h =
          Math.abs(Math.sin(t * Math.PI * 9.3)) * 16 +
          Math.abs(Math.sin(t * Math.PI * 18.7 + 0.8)) * 9 +
          Math.abs(Math.sin(t * Math.PI * 4.2 + 1.3)) * 7 +
          Math.abs(Math.sin(t * Math.PI * 33 + 0.3)) * 3;
        return Math.max(3, Math.min(30, h));
      });
    },
    playedCount() {
      return Math.floor(76 * 0.38);
    },
  },
  methods: {
    onAvatarError(e) {
      e.target.style.background = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
      e.target.style.display = 'block';
      e.target.src = '';
    },
  },
};
</script>

<style lang="scss" scoped>
// ── Tokens ───────────────────────────────────────────────────────────────────
$card-radius:   14px;
$inner-radius:  10px;
$border-color:  #e2e2e5;
$bg-header:     #f6f6f8;
$bg-body:       #ffffff;
$text-primary:  #111111;
$text-secondary:#888888;
$text-muted:    #b8b8be;
$orange:        #f97316;
$orange-faint:  rgba(249, 115, 22, 0.22);
$green:         #22c55e;
$font-mono:     'SF Mono', 'Fira Mono', 'Consolas', monospace;

// ── Scene (full-bleed backdrop) ───────────────────────────────────────────────
.agent-scene {
  align-items: center;
  background-color: #f4f5f6;
  background-image:
    linear-gradient(
      to right,
      transparent calc(50% - 310px),
      rgba(0, 0, 0, 0.08) calc(50% - 310px),
      rgba(0, 0, 0, 0.08) calc(50% - 309px),
      transparent calc(50% - 309px),
      transparent calc(50% + 309px),
      rgba(0, 0, 0, 0.08) calc(50% + 309px),
      rgba(0, 0, 0, 0.08) calc(50% + 310px),
      transparent calc(50% + 310px)
    ),
    repeating-linear-gradient(
      45deg,
      transparent 0,
      transparent 22px,
      rgba(0, 0, 0, 0.04) 22px,
      rgba(0, 0, 0, 0.04) 23px
    );
  border-radius: 8px;
  display: flex;
  justify-content: center;
  min-height: 100vh;
  padding: 40px 20px;
  width: 100%;
}

// ── Card shell ────────────────────────────────────────────────────────────────
.agent-card {
  background: $bg-body;
  border: 1px solid $border-color;
  border-radius: $card-radius;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.07), 0 1px 3px rgba(0, 0, 0, 0.04);
  max-width: 520px;
  overflow: hidden;
  width: 100%;

  // ── Header ────────────────────────────────────────────────────────────────
  &__header {
    align-items: center;
    background: $bg-header;
    border-bottom: 1px solid $border-color;
    display: flex;
    justify-content: space-between;
    padding: 11px 18px;
  }

  // ── Body ──────────────────────────────────────────────────────────────────
  &__body {
    padding: 20px 20px 0;
    position: relative;
  }

  // ── Divider ───────────────────────────────────────────────────────────────
  &__divider {
    border: none;
    border-top: 1px solid #f0f0f3;
    margin: 20px 0 14px;
  }

  // ── Footer ────────────────────────────────────────────────────────────────
  &__footer {
    align-items: center;
    border-top: 1px solid #f0f0f3;
    display: flex;
    justify-content: space-between;
    margin-top: 18px;
    padding: 13px 18px;
  }
}

// ── Header internals ──────────────────────────────────────────────────────────
.header__title {
  color: #4a4a4e;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: -0.01em;
}

.header__owner {
  align-items: center;
  display: flex;
  gap: 6px;

  &-avatar {
    border-radius: 50%;
    height: 20px;
    object-fit: cover;
    width: 20px;
  }

  &-label {
    color: $text-secondary;
    font-size: 12px;

    strong {
      color: $text-primary;
      font-weight: 600;
    }
  }
}

// ── Status badge ──────────────────────────────────────────────────────────────
.status-badge {
  align-items: center;
  display: flex;
  gap: 5px;
  position: absolute;
  right: 20px;
  top: 20px;

  &__dot {
    background: $green;
    border-radius: 50%;
    height: 7px;
    width: 7px;
  }

  &__text {
    color: $green;
    font-family: $font-mono;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.1em;
  }
}

// ── Profile row ───────────────────────────────────────────────────────────────
.agent-profile {
  display: flex;
  gap: 16px;
  margin-bottom: 0;

  &__avatar-wrap {
    background: #1b1b2a;
    border-radius: $inner-radius;
    flex-shrink: 0;
    height: 86px;
    overflow: hidden;
    width: 72px;
  }

  &__avatar {
    display: block;
    height: 100%;
    object-fit: cover;
    width: 100%;
  }

  &__info {
    padding-top: 2px;
  }

  &__name {
    color: $text-primary;
    font-size: 30px;
    font-weight: 700;
    letter-spacing: -0.02em;
    line-height: 1;
    margin: 0 0 5px;
  }

  &__role {
    color: $text-muted;
    font-family: $font-mono;
    font-size: 10.5px;
    letter-spacing: 0.07em;
    margin: 0 0 13px;
  }

  &__badges {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
  }
}

// ── Tool badges ───────────────────────────────────────────────────────────────
.tool-badge {
  align-items: center;
  background: #ffffff;
  border: 1px solid #e4e4e8;
  border-radius: 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  color: #333;
  display: inline-flex;
  font-size: 11px;
  font-weight: 500;
  gap: 5px;
  padding: 4px 10px 4px 7px;

  &__icon {
    flex-shrink: 0;
    height: 13px;
    width: 13px;
  }

  &--count {
    background: #f4f4f6;
    border-color: #e4e4e8;
    color: $text-secondary;
    padding: 4px 10px;
  }
}

// ── Current task ──────────────────────────────────────────────────────────────
.agent-task {
  &__label {
    color: $text-muted;
    display: block;
    font-family: $font-mono;
    font-size: 9px;
    letter-spacing: 0.13em;
    margin-bottom: 9px;
    text-transform: uppercase;
  }

  &__waveform {
    align-items: center;
    display: flex;
    gap: 2px;
    height: 38px;
    margin-bottom: 8px;
    overflow: hidden;
  }

  &__meta {
    display: flex;
    justify-content: space-between;
  }

  &__name {
    color: #333;
    font-family: $font-mono;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.07em;
  }

  &__tokens {
    color: $text-muted;
    font-family: $font-mono;
    font-size: 10px;
    letter-spacing: 0.05em;
  }
}

// ── Waveform bars ─────────────────────────────────────────────────────────────
.waveform-bar {
  background: $orange-faint;
  border-radius: 2px;
  flex-shrink: 0;
  transition: height 0.2s ease;
  width: 3px;

  &--played {
    background: $orange;
  }
}

// ── Footer ────────────────────────────────────────────────────────────────────
.footer-controls {
  align-items: center;
  display: flex;
  gap: 6px;
}

.btn-icon {
  align-items: center;
  background: none;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 5px 6px;
  transition: background 0.15s;

  &:hover {
    background: #f2f2f4;
  }
}

.btn-pause {
  align-items: center;
  background: none;
  border: 1px solid $border-color;
  border-radius: 6px;
  color: #666;
  cursor: pointer;
  display: flex;
  font-family: $font-mono;
  font-size: 9.5px;
  gap: 5px;
  letter-spacing: 0.09em;
  padding: 5px 11px;
  transition: background 0.15s;

  &:hover {
    background: #f5f5f7;
  }
}

.footer-info {
  align-items: center;
  display: flex;
  gap: 10px;

  &__last-active {
    color: $text-muted;
    font-family: $font-mono;
    font-size: 9.5px;
    letter-spacing: 0.07em;
  }
}

.btn-details {
  background: $text-primary;
  border: none;
  border-radius: 7px;
  color: #fff;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  padding: 7px 14px;
  transition: background 0.15s;

  &:hover {
    background: #333;
  }
}
</style>
